<template>
  <div class="record_index">
    <h1
      class="title"
      v-text="title"
    />
    <div class="notice_list scroll_bar_beautify_ff">
      <template v-for="(item, index) in noticeDataList">
        <notice-item
          :id="item.id"
          :key="item.id"
          :index="index"
          :date="item.date"
          :time="item.time"
          :title="item.title"
          :content="item.content"
          :isread="item.isread"
          :inquiryid="item.inquiryid"
          :attribute="item.attribute"
          @click="changeStatus"
        />
      </template>
      <div class="load_more_btn">
        <a-button
          v-if="noticeTotal >= 6 && !loadingComplete"
          @click="loadMore"
        >
          {{ $t('message["472"]') }}
        </a-button>
        <div
          v-if="noticeTotal === 0 && !loadingContent"
          class="no_data"
        >
          <p><i class="iconfont iconicon-test38 logo" /></p>
          <p>
            {{ $t('message["1553"]') }}
          </p>
        </div>
      </div>
    </div>
    <a-spin
      v-if="loadingContent"
      class="spin-style"
    />
  </div>
</template>

<script type="text/ecmascript-6">
import { mapState, mapActions, mapMutations } from 'vuex'
import noticeItem from './components/NoticeItem'
import { formatTime, matchFromUrl } from './common'

const FROM_SOPURCE = 'notice'

export default {
  components: {
    noticeItem
  },
  data () {
    return {
      page: 1
    }
  },
  computed: {
    ...mapState('record', ['noticeList', 'noticeTotal', 'loadingContent', 'loadingComplete']),
    ...mapState(['baseinfo']),
    noticeDataList () {
      return this.noticeList.map(item => {
        const { date, time } = formatTime(item.addtime)
        item.date = date
        item.time = time
        if (item.title === this.smartText) {
          item.content = matchFromUrl(item.content)
        }
        return item
      })
    },
    title () {
      const { title } = this.$route.meta
      return title
    },
    pid () {
      return this.$route.params.pid
    },
    smartText () {
      return this.$t('message["1248"]')
    }
  },
  watch: {
    baseinfo (newVal) {
      document.title = this.title + ' - ' + newVal.projectname + '-' + newVal.comname
    }
  },
  async created () {
    await this.getNoticeData()
  },
  destroyed () {
    this.initNoticeStore()
  },
  methods: {
    ...mapActions('record', ['getNoticeData', 'updateNoticeStatus', 'initNoticeStore']),
    ...mapActions('notice', ['fetchInquiryDetail']),
    ...mapMutations('record', ['updateNoticeItem']),
    ...mapMutations(['setBaseInfoField', '']),
    async changeStatus (event) {
      const { id, index, title, inquiryid, isread, attribute } = event
      const { followupid = 0, replyid = 0, commentid = 0 } = this.$toType(attribute) === 'object' ? attribute : {}
      let query = {
        // type: 'inquiry-manager-all',
        from: FROM_SOPURCE,
        replyid
      }
      if (followupid) {
        query.followupid = followupid
        query.tab2 = 'returnVisite'
      } else if (commentid) {
        query.commentid = commentid
        query.tab2 = 'commentContent'
      }

      isread === 1 && this.toNoticeDetail(title, inquiryid, query)
      if (isread === 0) {
        let params = { id, index }
        const chain = await this.updateNoticeStatus(params)
        chain.onSuccess(async (res) => {
          this.setBaseInfoField({ field: 'unread_notice_num', num: this.baseinfo.unread_notice_num-- })
          await this.updateNoticeItem(params)
        })
          .onNetComplete(() => {
            this.toNoticeDetail(title, inquiryid, query)
          })
          .fetch()
      }
    },
    // 点击加载更多
    loadMore () {
      if (!this.loadingComplete) {
        this.getNoticeData(++this.page)
      }
    },
    // 跳转到通知详情
    async toNoticeDetail (title, inquiryid, query) {
      if (title.includes(this.$t('message["1500"]'))) {
        this.$router.push({ name: 'ServiceEmail' })
      } else if (title.includes(this.$t('message["251"]'))) {
        this.$router.push({ name: 'ServiceSms' })
      } else if (inquiryid && inquiryid !== 0 && title !== this.smartText) {
        const auditStatus = await this.getInquiryStatus(inquiryid)
        this.$router.push({
          // path: `/project/${this.pid}/inquery/detail/${inquiryid}`,
          name: auditStatus === 1 ? 'InqueryPassDetail' : 'InqueryDetail',
          params: {
            pid: this.pid,
            inquiryId: inquiryid
          },
          query
        })
      } else if (title.includes('线索联系提醒')) {
        this.$router.push({
          name: 'InqueryClue',
          query: {
            istoday: 1,
            scope: 'myfollow'
          }
        })
      } else {
        // console.log('万能表单')
      }
    },
    async getInquiryStatus (inquiryid) {
      let params = {
        inquiryid,
        from: 'notice'
      }
      return new Promise(async (resolve, reject) => {
        const chain = await this.fetchInquiryDetail(params)

        chain
          .onSuccess(payload => {
            // console.log(payload)
            let auditStatus = payload && payload.audit_status
            // const arr = Object.keys(payload).map(key => payload[key])
            resolve(auditStatus)
          })
          .onNetFail(err => {
            reject(err)
          })
          .fetch()
      })
    }
  }
}
</script>

<style scoped lang="scss">
.record_index {
  .notice_list {
    max-height: 100vh;
    overflow-y: auto;
    overflow-x: hidden;
  }
  .load_more_btn {
    margin: 24px 12px;
  }
  .no_data {
    width: 1040px;
    margin-top: 40px;
    .logo {
      font-size: 24px;
    }
    p {
      text-align: center;
      height: 24px;
      font-size: 14px;
      font-weight: 400;
      color: rgba(179, 179, 179, 1);
      line-height: 24px;
      margin-bottom: 8px;
    }
  }
  .spin-style {
    position: absolute;
    top: 50%;
    left: 50%;
  }
}
</style>
